export const Line = () => <span>-------------</span>